import React, { useEffect } from 'react'
import './App.css';
import { 
  BrowserRouter as Router,
  Switch,
  Route,
 } from 'react-router-dom';
import Home from './View/Home';
import Udesh from './View/Udesh';
import Cometee from './View/Cometee';
import Donation from './View/Donation';
import Gallary from './View/Gallary';
import Contact from './View/Contact';
import Login from './View/Login';
import SignUp from './View/SignUp';
import GuestCheckout from './View/GuestCheckout';
import ForgotPassword from './View/ForgotPassword';
import ChangePassword from './View/ChangePassword';
import DonationHistory from './View/DonationHistory';
import Profile from './View/Profile';
import PageView from './View/PageView';
import ManageApp from './manage/ManageApp';
import ForcePasswordChange from './Component/ForcePasswordChange';
import { ROUTER_BASENAME } from './config';
import { Redirect } from 'react-router-dom';
import { GetAction } from './Component/GetAction';
import { applyFavicon } from './utils/applyFavicon';

function App() {
  useEffect(() => {
    GetAction('get', {}, 'settings/get').then((data) => {
      if (data?.status !== 'success' || !data.response) return
      const r = data.response
      if (r.website_name) document.title = r.website_name
      if (r.favicon_path) applyFavicon(r.favicon_path)
    })
  }, [])

  return (
    <>
      <Router basename={ROUTER_BASENAME}>
        <ForcePasswordChange />
        <Switch >
        <Route exact path ="/">
          <Home  />
        </Route>
        <Route exact path ="/Home">
          <Home  />
        </Route>
        <Route exact path ="/Udesh">
          <Udesh  />
        </Route>
        <Route exact path ="/Cometee">
          <Cometee  />
        </Route>
        <Route exact path ="/Donation">
          <Donation  />
        </Route>
        <Route exact path ="/Gallary">
          <Gallary  />
        </Route>
        <Route exact path ="/Contact">
          <Contact  />
        </Route>
        <Route exact path="/page/:pageId">
          <PageView />
        </Route>
        <Route exact path ="/Login">
          <Login  />
        </Route>
        <Route exact path ="/ForgotPassword">
          <ForgotPassword />
        </Route>
        <Route exact path ="/ChangePassword">
          <ChangePassword />
        </Route>
        <Route exact path ="/SignUp">
          <SignUp  />
        </Route>
        <Route exact path="/GuestCheckout">
          <GuestCheckout />
        </Route>
        <Route exact path ="/DonationHistory">
          <DonationHistory  />
        </Route>
        <Route exact path ="/Profile">
          <Profile  />
        </Route>
        <Route path="/manage">
          <ManageApp />
        </Route>
        <Route exact path="/:pageSlug">
          <PageView />
        </Route>
        <Route path="*">
          <Redirect to="/" />
        </Route>
      </Switch>
      </Router>
    </>
  );
}

export default App;
